import { defineStore } from 'pinia';

export const useStore = defineStore('store', {
    state: (): Record<string, any> => {
        return {
            isAnswered: false, // 是否已答题
            indexData: {
                level: {},
                user_info: {
                    accumulate_read_day: 0,
                },
                spiritual_power_value: {},
                magic_weapon: {},
            },
            popData: {},
            popStatus: {
                get: false, // 获得法宝、奖品
                noget: false, // 未获得法宝
                view: false, // 查看法宝
                viewAward: false, // 查看奖品
            },
            // 法宝
            magicWeapon: {},
            // 关注
            followList: [],
            svgaFiles: {},
        };
    },
    actions: {
        setIsAnswered(value: boolean) {
            this.isAnswered = value;
        },
        setIndexData(data: Record<string, any>) {
            this.indexData = data;
        },
        setPopStatus(key: string, value: boolean) {
            this.popStatus[key] = value;
        },
        setPopData(data: Record<string, any>) {
            this.popData = data;
        },
        setMagicWeapon(data: Record<string, any>) {
            this.magicWeapon = data;
        },
        setFollowList(data: Record<string, any>) {
            this.followList = data;
        },
        setSvgaFiles(name: string, data: any) {
            this.svgaFiles[name] = data;
        },
    },
});
